import { defineNuxtPlugin } from "#app";
import { setTheme, useThemeListState, useThemeResource } from "#imports";

export default defineNuxtPlugin( {
  name: "apollo-theme",
  parallel: true,
  async setup () {
    const { listThemes } = useThemeResource();

    const themes = await listThemes();

    if ( import.meta.server ) {
      // only need to set this once
      const themesState = useThemeListState();
      themesState.value = themes.data.value ?? [];
    }

    setTheme();
  },
} );
